<div
  *ngIf="sale"
  class="sales-card"
  id="sales-card"
  [class.popular]="true"
  [style.backgroundImage]="'url(' + sale.style.backgroundPattern + ')'"
  [style.backgroundSize]="'cover'">
  <h4 class="bold" [style.color]="sale.style.textColor">
    {{ sale.title }}
  </h4>

  <p class="regular" style="color: white">
    {{ sale.description }}
  </p>
  <ion-list>
    <ion-item
      *ngFor="let saleDetail of sale.saleDetails; trackBy: trackSaleDetailsBy; last as last"
      [lines]="'none'"
      class="condensed">
      <ion-icon
        *ngIf="appearance === 'upgrade'"
        src="/assets/icons/24px/check.svg"
        slot="start"
        [style.color]="sale.style.textColor"></ion-icon>
      <ion-avatar slot="start" *ngIf="appearance === 'auth' || 'subscription'">
        <ion-img src="{{ saleDetail.saleDetailIcon }}"></ion-img>
      </ion-avatar>

      <ion-label class="ion-text-wrap" [innerHtml]="saleDetail.saleDetailText"> <br /> </ion-label>
    </ion-item>
  </ion-list>
  <ion-button
    *ngIf="appearance === 'subscription' && !isCouponRedeemed"
    [routerLink]="['/upgrade']"
    [queryParams]="{ yearly: 'true' }"
    [disabled]="disabled"
    id="sale"
    class="sale-button"
    style="--background: {{ sale.style.buttonColor }} !important">
    <ion-img src="assets/images/Icon-HolidayTag.png"></ion-img>{{ sale.style.buttonText }}
  </ion-button>
  <ion-button
    *ngIf="appearance === 'subscription' && isCouponRedeemed"
    [disabled]="disabled"
    id="sale"
    class="sale-button"
    style="--background: {{ sale.style.buttonColor }} !important">
    <ion-img src="assets/images/Icon-HolidayTag.png"></ion-img>Coupon Redeemed!
  </ion-button>
  <ion-row id="partners" *ngIf="appearance === 'subscription' || 'auth'">
    <img src="/assets/images/Holiday_Partners_SquadCast-White.png" alt="SquadCast logo" />
    <img src="/assets/images/Holiday_Partners_Cavna-White.png" alt="Canva logo" />
    <img src="/assets/images/Holiday_Partners_Headliner-White.png" alt="Headliner logo" />
    <img src="/assets/images/Holiday_Partners_Alitu-White.png" alt="Alitu logo" />
    <img src="/assets/images/Holiday_Partners_Transistor-White.png" alt="Transistor logo" />
  </ion-row>
  <p class="ion-text-wrap micro-regular" color="lightest">
    **Limited number of full packages available while supplies last. <br />
    Coupons will be emailed within 48 hours of purchase.**
  </p>
</div>
